import { render, staticRenderFns } from "./EditGPPage.vue?vue&type=template&id=4f246f98&"
import script from "./EditGPPage.vue?vue&type=script&lang=js&"
export * from "./EditGPPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports